const HEADER_OFFSET = 200; // Offset for sticky header
const ANIMATION_DELAY = 50;

document.addEventListener('DOMContentLoaded', () => {
    const missionBlocks = document.querySelectorAll('.tabs-section');

    missionBlocks.forEach(block => {
        const navItems = block.querySelectorAll('.tabs-section__nav-item');
        const panels = block.querySelectorAll('.tabs-section__panel');

        [...navItems].forEach(button => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-tab-target');

                // 1. Remove active classes
                navItems.forEach(item => {
                    item.classList.remove('is-active');
                    item.setAttribute('aria-expanded', 'false');
                });
                panels.forEach(panel => {
                    panel.classList.remove('is-active');
                });

                // 2. Add active classes to current selection
                button.classList.add('is-active');
                button.setAttribute('aria-expanded', 'true');
                
                const activePanel = block.querySelector(`#${targetId}`);
                if (activePanel) {
                    activePanel.classList.add('is-active');

                    if (window.innerWidth < 993) {
                        setTimeout(() => {
                            scrollToActivePanel(activePanel);
                        }, ANIMATION_DELAY);
                    }
                }
            });
        });
    });
});

function scrollToActivePanel(target) {
    if (!target) return;

    // Scroll to the Active Panel 
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = rect.top + scrollTop - HEADER_OFFSET;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
}